import format from 'date-fns/format';
import { isString } from './helpers';
export var formatDate = function formatDate(date, formatter) {
  if (isString(formatter)) {
    return isDateRange(date) ? "".concat(format(date.from, formatter), " - ").concat(format(date.to, formatter)) : format(date, formatter);
  } else {
    return isDateRange(date) ? "".concat(formatter(date.from), " - ").concat(formatter(date.to)) : formatter(date);
  }
};
export var isDateRange = function isDateRange(date) {
  return date && date.from instanceof Date && date.to instanceof Date;
};